import { COMMON_UI_I18N } from "./commonUiI18n";

type PublicApiErrorCodeKey = keyof typeof COMMON_UI_I18N.publicApiErrors;

export function resolvePublicApiErrorMessage(code: string | undefined, rawMessage: string): string {
	if (code && code in COMMON_UI_I18N.publicApiErrors) {
		return COMMON_UI_I18N.publicApiErrors[code as PublicApiErrorCodeKey];
	}
	return rawMessage;
}
